import { render } from "./Spark-Sidebar.vue?vue&type=template&id=2a77e6e0&ts=true"
import script from "./Spark-Sidebar.vue?vue&type=script&lang=ts"
export * from "./Spark-Sidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/Spark/Spark/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__